import Glide from '@glidejs/glide'
import {options} from "./components/options";
gsap.registerPlugin(ScrollTrigger, Flip);

document.addEventListener("DOMContentLoaded", function() {
  options();

  let scrollObject = {};
  window.onscroll = getScrollPosition;
  const main = document.getElementById('header');

  function getScrollPosition() {
    scrollObject = {
      x: window.pageXOffset,
      y: window.pageYOffset
    }
    if (scrollObject.y > 50) {
      main.classList.add('is-active');
    } else {
      main.classList.remove('is-active');
    }
  }

// Nav mobile
  const body = document.body;
  const navicon = document.getElementById('navicon');
  const nav = document.getElementById('main-nav');
  const subMenuWrapper = document.querySelector('.main-header--wrapper');
  navicon.onclick = function () {
    if (navicon.classList.contains('active')) {
      navicon.classList.replace('active', 'passive');
      body.classList.toggle('nav-open');
      nav.classList.toggle('active');
      subMenuWrapper.classList.remove('sub-menu-open');
    } else {
      navicon.classList.replace('passive', 'active');
      body.classList.toggle('nav-open');
      nav.classList.toggle('active');
    }
  }

  const btnMenu = nav.querySelectorAll('a');
  btnMenu.forEach(btn => {
    btn.addEventListener('click', (e) => {
      if(btn.parentNode.classList.contains('has-sub-menu')) {
        // do nothing
      } else {
        nav.classList.remove('active')
        body.classList.remove('nav-open')
        navicon.classList.replace('active', 'passive')
      }
    });
  })

  document.querySelectorAll('.has-sub-menu > a').forEach(anchor => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault();

      const subMenu = this.parentElement.querySelector('.dropdown-menu');
      const menuWrapper = document.querySelector('.main-header--wrapper');

      if (subMenu && subMenu.classList.contains('is-open')) {
        subMenu.classList.remove('is-open');
        menuWrapper.classList.remove('sub-menu-open');
        this.classList.remove('is-active');
      } else {
        document.querySelectorAll('.dropdown-menu.is-open').forEach(openMenu => {
          openMenu.classList.remove('is-open');
        });
        document.querySelectorAll('.has-sub-menu > a.is-active').forEach(activeLink => {
          activeLink.classList.remove('is-active');
        });
        menuWrapper.classList.remove('sub-menu-open');

        if (subMenu) {
          subMenu.classList.add('is-open');
          menuWrapper.classList.add('sub-menu-open');
          this.classList.add('is-active');
        }
      }
    });
  });


  let hrefs = document.querySelectorAll('a[href^="#"]')
  for (let i = 0; i < hrefs.length; i++) {
    hrefs[i].addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  }

  let carousel = document.getElementById('slider');
  if (carousel) {
    let glide = new Glide('#slider', {
      type: 'slider',
      perView: 3,
      rewind: false,
      keyboard: true,
      animationDuration: 1200,
      breakpoints: {
        1600: {
          perView: 3,
        },
        800: {
          perView: 3
        },
        600: {
          perView: 3
        },
        480: {
          perView: 1,
        }
      }
    });
    glide.mount()
  }

  let timeline = document.getElementById('timeline');
  if (timeline) {
    let glide = new Glide('#timeline', {
      type: 'carousel',
      perView: 1,
      rewind: false,
      keyboard: true,
      gap: 20,
      animationDuration: 1200,
    });
    glide.mount()
  }

  let carousel_post = document.getElementById('post-slider');
  if (carousel_post) {
    let glide = new Glide('#post-slider', {
      type: 'slider',
      perView: 3,
      rewind: false,
      keyboard: true,
      gap: 20,
      animationDuration: 800,
      breakpoints: {
        1600: {
          perView: 3,
        },
        1199: {
          perView: 3
        },
        991: {
          perView: 2
        },
        768: {
          perView: 2,
        },
        480: {
          perView: 1,
          gap: 0,
        }
      }
    });
    glide.mount()
  }

  let carousel_application = document.getElementById('application-slider');
  if (carousel_application) {
    let glide = new Glide('#application-slider', {
      type: 'slider',
      perView: 4,
      rewind: false,
      keyboard: true,
      gap: 20,
      animationDuration: 800,
      breakpoints: {
        1600: {
          perView: 4,
        },
        1199: {
          perView: 3
        },
        991: {
          perView: 3
        },
        768: {
          perView: 2,
        },
        480: {
          perView: 1,
          gap: 0,
        }
      }
    });
    glide.mount()
  }

// animation transition
  let banners = document.querySelectorAll('.animate')
  banners.forEach((item) => {
    ScrollTrigger.create({
      start: 0,
      end: "max",
      onUpdate: updateValues
    });

    function updateValues() {
      if (ScrollTrigger.isInViewport(item)) {
        item.classList.add('is-visible')
      }
    }

    updateValues();
  });

// filters for product cat //
  const product_buttons = document.querySelectorAll('.btn-collapse');
  const product_collapse = document.querySelectorAll('.collapse-div');
  if (product_collapse) {
    product_buttons.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        const toShow = document.getElementById(element.id + '-div')

        toShow.classList.toggle('is-visible')
        element.classList.toggle('is-active')

        if (toShow.classList.contains('is-visible')) {
          toShow.style.height = toShow.scrollHeight + 'px';
        } else {
          toShow.style.height = '0px'
        }

      });
    });
  }

  let modalBtn = document.querySelectorAll('.btn-download');
  const modal = document.getElementById('contact-modal');
  const modalClose = document.getElementById('close-modal');
  if (modal) {
    modalBtn.forEach(element => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        element.classList.toggle('active');
        modal.classList.add('active');
        body.classList.add('modal-open');
      });
    });
    modalClose.onclick = function () {
      modal.classList.remove('active');
      body.classList.remove('modal-open');
      modalBtn.forEach(item => {
        item.classList.remove('active')
      })
    }
  }
});




function initFlipOnScroll() {
  let wrapperElements = document.querySelectorAll("[data-flip-element='wrapper']");
  let targetEl = document.querySelector("[data-flip-element='target']");

  if (!wrapperElements.length || !targetEl) return;

  let tl;

  function flipTimeline() {
    if (tl) {
      tl.kill();
      gsap.set(targetEl, { clearProps: "all" });
    }

    tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapperElements[0],
        start: "center center",
        endTrigger: wrapperElements[wrapperElements.length - 1],
        end: "center 55%",
        scrub: 0.25
      }
    });

    wrapperElements.forEach(function(element, index) {
      let nextIndex = index + 1;
      if (nextIndex < wrapperElements.length) {
        let nextWrapperEl = wrapperElements[nextIndex];
        let nextRect = nextWrapperEl.getBoundingClientRect();
        let thisRect = element.getBoundingClientRect();
        let nextDistance = nextRect.top + window.pageYOffset + nextWrapperEl.offsetHeight / 2;
        let thisDistance = thisRect.top + window.pageYOffset + element.offsetHeight / 2;
        let offset = nextDistance - thisDistance;

        tl.add(
          Flip.fit(targetEl, nextWrapperEl, {
            duration: offset,
            ease: "none"
          })
        );
      }
    });
  }

  flipTimeline();

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      flipTimeline();
    }, 100);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth >= 768) {
    initFlipOnScroll();
  }
});

